// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import BrandingProfileFormController from './branding_profile_form_controller'
application.register('branding-profile-form', BrandingProfileFormController)

import BrandingProfileSelectController from './branding_profile_select_controller'
application.register('branding-profile-select', BrandingProfileSelectController)

import DocumentPlacerController from './document_placer_controller'
application.register('document-placer', DocumentPlacerController)

import DocumentViewerController from './document_viewer_controller'
application.register('document-viewer', DocumentViewerController)

import DropdownController from './dropdown_controller'
application.register('dropdown', DropdownController)

import DynamicSignersController from './dynamic_signers_controller'
application.register('dynamic-signers', DynamicSignersController)

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import ComplianceCheckboxController from './compliance_checkbox_controller'
application.register('compliance-checkbox', ComplianceCheckboxController)

import DisclosureController from './disclosure_controller'
application.register('disclosure', DisclosureController)

import FilterController from './filter_controller'
application.register('filter', FilterController)

import IframeMessengerController from './iframe_messenger_controller'
application.register('iframe-messenger', IframeMessengerController)

import InlineConfirmController from './inline_confirm_controller'
application.register('inline-confirm', InlineConfirmController)

import ModeVisibilityController from './mode_visibility_controller'
application.register('mode-visibility', ModeVisibilityController)

import OtpChannelToggleController from './otp_channel_toggle_controller'
application.register('otp-channel-toggle', OtpChannelToggleController)

import OtpInputController from './otp_input_controller'
application.register('otp-input', OtpInputController)

import PasswordToggleController from './password_toggle_controller'
application.register('password-toggle', PasswordToggleController)

import PlacementPreviewController from './placement_preview_controller'
application.register('placement-preview', PlacementPreviewController)

import PhoneInputController from './phone_input_controller'
application.register('phone-input', PhoneInputController)

import ResendTimerController from './resend_timer_controller'
application.register('resend-timer', ResendTimerController)

import SignatureSessionFormController from './signature_session_form_controller'
application.register('signature-session-form', SignatureSessionFormController)

import SigningFlowController from './signing_flow_controller'
application.register('signing-flow', SigningFlowController)

import SlideoverController from './slideover_controller'
application.register('slideover', SlideoverController)

import SlideoverTriggerController from './slideover_trigger_controller'
application.register('slideover-trigger', SlideoverTriggerController)

import TabsController from './tabs_controller'
application.register('tabs', TabsController)
